import React from 'react';
import { Container } from '@mui/material';
import RetornoForm from '../components/saida/RetornoForm';

const SaidaRetorno: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <RetornoForm />
    </Container>
  );
};

export default SaidaRetorno;
